import React, { useEffect, useState } from 'react'
import { ProgressBar } from 'react-bootstrap'
import { useSessionAvailability } from '../ScopedBlock/hooks'
import { Link } from 'react-router-dom'
import './FreeTierLimitIndicator.scss'
import { useGetBillingCustomerQuery } from '../../store/plan/plan'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { dateDiffInDays } from '../../common/util'

export const FreeTrialLimitIndicator: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)

  const [maxRoomSessions, setMaxRoomSessions] = useState(0)
  const [usedRoomSessions, setUsedRoomSessions] = useState(0)
  const { maxSessionsInPeriod, usedSessionsInPeriod, isSuccess: sessionAvailabilitySuccess } = useSessionAvailability()
  const { data: customer } = useGetBillingCustomerQuery({ accountId })
  const freeTrialDays =
    customer && customer.data.freeTrial && !customer.data.freeTrial.endedAt && customer.data.subscription
      ? dateDiffInDays(new Date(customer.data.subscription.currentPeriodStart), new Date(customer.data.subscription.currentPeriodEnd))
      : 0
  const usedFreeTrialDays =
    customer && customer.data.freeTrial && customer.data.subscription && !customer.data.freeTrial.endedAt
      ? dateDiffInDays(new Date(customer.data.subscription.currentPeriodStart), new Date())
      : 0

  useEffect(() => {
    if (sessionAvailabilitySuccess) {
      setMaxRoomSessions(maxSessionsInPeriod ?? 0)
      setUsedRoomSessions(usedSessionsInPeriod)
    }
  }, [sessionAvailabilitySuccess, maxSessionsInPeriod, usedSessionsInPeriod])
  return (
    <>
      {sessionAvailabilitySuccess && maxRoomSessions > 0 && (
        <div className='d-flex flex-column gap-2 justify-content-center'>
          <div className='d-flex gap-3'>
            <div className='text-nowrap'>
              {usedRoomSessions}/{maxRoomSessions} meetings
            </div>
            <Link className='zocks-text-gray-900 medium text-decoration-underline paragraph-medium' to='/account/plan/plan'>
              Upgrade
            </Link>
          </div>
          <ProgressBar
            className='progress-sm'
            now={Math.floor((usedRoomSessions / maxRoomSessions) * 100)}
            variant={usedRoomSessions >= maxRoomSessions ? 'danger' : 'success'}
          />
        </div>
      )}
      {customer && !maxRoomSessions && customer.data.freeTrial && (
        <div className='d-flex flex-column gap-2 justify-content-center'>
          <div className='d-flex gap-3'>
            <div className='text-nowrap'>
              {usedFreeTrialDays}/{freeTrialDays} days
            </div>
            <Link className='zocks-text-gray-900 medium text-decoration-underline paragraph-medium' to='/account/plan/plan'>
              Upgrade
            </Link>
          </div>
          <ProgressBar className='progress-sm' now={Math.floor((usedFreeTrialDays / freeTrialDays) * 100)} variant={'success'} />
        </div>
      )}
    </>
  )
}
